/**
 * Single Auth Hook - the new recommended way to access auth data
 * This provides everything in one hook with optimal performance
 */

import { useSimplifiedAuth } from '@/contexts/SimplifiedAuthContext';

export const useAuth = () => {
  return useSimplifiedAuth();
};

// Export for convenience
export default useAuth;